import { render, staticRenderFns } from "./FixStore.vue?vue&type=template&id=9f6a1e82"
import script from "./FixStore.vue?vue&type=script&lang=js"
export * from "./FixStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports